import React from 'react';
import type { FunctionComponent } from 'react';
import { useAppDispatch } from '../../../store/store';
import { renderAccountDetails } from '../../../store/accountListSlice';
import { setFeatureToShow } from '../../../store/paymentTokenSlice';
import {
  setImagePath,
  detectDeviceType,
  handleTabAction,
} from '../../../utils/helpers';
import { captureAnalyticsDataAttributes } from '../../../utils/analytics/analyticsDispatchers';
import { FEATURES_TO_DISPLAY } from '../../../utils/constants/genericConstants';
import '../../singleUseCard/singleUseCard.css';

interface SingleUseCardLinkProps {
  accountId: string;
  singleUseCardButtonText: string;
  displayName: string;
  isAccordionCollapsed: boolean;
}

const SingleUseCardLink: FunctionComponent<SingleUseCardLinkProps> = ({
  accountId,
  displayName,
  singleUseCardButtonText,
  isAccordionCollapsed,
}) => {
  const dispatch = useAppDispatch();
  const handleSingleUseCardClick = (event: any) => {
    // update redux flag here to hide account details and show selected feature
    dispatch(
      renderAccountDetails({
        accountId,
        renderAccountDetailsDisplayFlag: false,
      }),
    );
    dispatch(setFeatureToShow(FEATURES_TO_DISPLAY.SINGLE_USE_CARD));
    captureAnalyticsDataAttributes(event);
  };

  return (
    <div className="single-use-card-link-content">
      <div
        className="single-use-card-img-wrapper"
        data-type={detectDeviceType}
        data-reason={`AccessSingleUseCard:${displayName}`}
        data-object="button"
        onClick={handleSingleUseCardClick}
        data-testid="single-use-card-click"
        tabIndex={isAccordionCollapsed ? -1 : 0}
        onKeyDown={(e) => handleTabAction(e, handleSingleUseCardClick)}
        aria-label="single use card link"
      >
        <img src={setImagePath('single-use-card-link')} alt="single use card" />
        <a className="link-singleuse-card-text-block">
          {singleUseCardButtonText}
        </a>
      </div>
    </div>
  );
};

export default SingleUseCardLink;
